export const USER_LOADING = '@MATERIALS_USER_LOADING';
export const USER_LOADED = '@MATERIALS_LOADED';

export const GET_SERVICES = '@MATERIALS_GET_SERVICES';
export const GET_MATERIAL = '@MATERIALS_GET_MATERIAL';
export const REMOVE_MATERIAL = '@MATERIALS_DELETE_MATERIAL';
export const UPDATE_MATERIAL = '@MATERIALS_UPDATE_MATERIAL';
export const CREATE_MATERIAL = '@MATERIALS_CREATE_MATERIAL';


export const GET_RESELLING_SERVICES = '@MATERIALS_GET_RESELLING_SERVICES';